import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router";
import { useState } from "react";
import { FiDownload } from "react-icons/fi";
import { useAnalytics } from "~/lib/firebase/analytics";
import { downloadFile } from "~/utils/helper-funcations";

interface DownloadButtonProps {
  bgColor?: string;
  iconcolor?: string;
  size?: number;
  fileName: string;
  url: string;
}

const DownloadButton = ({ bgColor, iconcolor, fileName, url, size = 34 }: DownloadButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { trackDownload } = useAnalytics();
  const location = useLocation().pathname;

  const handleDownload = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLoading(true);
    try {
      await downloadFile(url, `${fileName}.pdf`);

      // Track the download event
      const componentName = location.includes("/sad-granth/")
        ? "SadGranthBookPage"
        : location.includes("/satsang-sevak")
        ? "SatsangSevakPage"
        : "DownloadButton";
      trackDownload(`${fileName}.pdf`, "pdf", componentName);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      className={`size-[${size}px] ${
        bgColor ? `bg-[${bgColor}]` : "bg-white"
      } flex justify-center items-center rounded-full p-1 cursor-pointer hover:bg-cardBg`}
      onClick={handleDownload}
      title="Download"
      disabled={isLoading}
    >
      {isLoading ? <CircularProgress size={20} sx={{ color: "#d05e2d" }} /> : <FiDownload size={21} color={iconcolor ? iconcolor : "#D97E57"} />}
    </button>
  );
};

export default DownloadButton;
